import React from 'react';

export const pinterestIcon = ({ ariaLabel = 'Pinterest' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      role="img"
      aria-label={ariaLabel}
    >
      <path d="M17 8.625a8.233 8.233 0 0 1-10.671 7.866c.335-.548.836-1.445 1.022-2.158l.512-1.96c.268.512 1.052.947 1.885.947 2.484 0 4.274-2.284 4.274-5.123 0-2.72-2.222-4.755-5.077-4.755-3.553 0-5.442 2.384-5.442 4.984 0 1.208.644 2.712 1.67 3.19.156.074.24.04.276-.109.026-.113.166-.674.229-.933a.247.247 0 0 0-.057-.236c-.335-.415-.607-1.172-.607-1.879 0-1.816 1.374-3.573 3.718-3.573 2.022 0 3.44 1.378 3.44 3.35 0 2.228-1.125 3.772-2.59 3.772-.806 0-1.414-.667-1.218-1.487.232-.98.68-2.035.68-2.743 0-.63-.338-1.158-1.042-1.158-.827 0-1.49.853-1.49 1.998 0 .73.245 1.222.245 1.222s-.814 3.447-.963 4.09c-.166.711-.1 1.714-.03 2.365a8.238 8.238 0 0 1-5.233-7.67A8.233 8.233 0 0 1 8.766.391 8.233 8.233 0 0 1 17 8.625Z" fill='none' stroke='#F6F3EC' />
    </svg>
  );
};
